// @ts-nocheck
import React from 'react';
import TopBar from '../../../Components/TopBar';

export default function ProfileEvaluation() {
  const UniversityRow = () => {
    return (
      <>
        <div className="px-6 py-4 bg-white rounded-md shadow-md">
          <h3 className="text-gray-800 cursor-pointer text-md"> University Of Toronto </h3>
          <div className="flex">
            <p className="px-2 -ml-2 text-xs">QCAS Ranking</p>
            <p className="px-2 text-xs">Visit Website</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <TopBar affiliatePage={false} />
      <div className="w-full min-h-screen bg-altBack font-brand">
        <div className="pt-32 mx-6 lg:m-auto lg:flex lg:w-2/3">
          <div className="lg:w-1/2">
            <h1 className="text-3xl font-bold text-brandcolor"> Profile Evaluation </h1>
            <div className="max-w-md">
              <p className="text-md">
                This tool uses QAS rankings from last 10 years and the acceptances over the years to map the best fit based on your profile. Learn how
                we calculate the score. <span className="underline">Learn how we calculate profile score to suggest universities. </span>
              </p>
              <div className="my-6">
                <div className="p-12 bg-darkAlt">
                  <p className="text-sm">
                    This tool uses QAS rankings from last 10 years and the acceptances over the years to map the best fit based on your profile.{' '}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2">
            <div id={'section'} className="mx-6">
              <div className="my-6">
                <h2 className="my-2 text-lg"> Target Universities 🎯 </h2>
                <p className="my-2 text-xs">The list of universities that you can actively aim as per your profile.</p>{' '}
              </div>
              <div className="my-6 space-y-2">
                <UniversityRow />
                <UniversityRow />
                <UniversityRow />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
